<div class="modal-header">
  <h5 class="modal-title" i18n>Select Billing Address</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-8 offset-sm-2">
      <ng-select
        [items]="items"
        [selectOnTab]="true"
        [clearable]="false"
        bindLabel="address"
        bindValue="key"
        formControlName="address"
        placeholder="Billing Address"
        i18n-placeholder
        class="mat-block"
        appendTo="body"
        required
      >
      </ng-select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="select(form)" class="btn btn-success text-uppercase create-btn" type="button">
    <i class="fal fa-check-square"></i> <ng-container i18n>OK</ng-container>
  </button>
</div>
